import { Component, inject, input, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { MarketView } from '@app/services/http/clients/api-proxies';
import { MarketService } from '@http/clients/market.service';
import { GenericDropdownComponent } from 'ngx-lib';
import { createValueAccessorProvider, FormEditorBase } from '../base/form-editor-base';

@Component({
    selector: 'app-market-form-editor',
    templateUrl: './market-form-editor.component.html',
    styleUrl: './market-form-editor.component.scss',
    providers: [createValueAccessorProvider(MarketFormEditorComponent)],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [GenericDropdownComponent]
})
export class MarketFormEditorComponent extends FormEditorBase<MarketView[]> implements OnInit {
    // Inputs for direct signal usage
    value = input<MarketView[]>();
    readonly = input<boolean>();
    placeholderText = input<string>('Select Market');

    private readonly marketService = inject(MarketService);

    constructor() {
        super();
    }

    ngOnInit(): void {
        this.loadMarkets();
    }

    onSelectedItemChange(selectedItem: any): void {
        if (selectedItem && selectedItem !== null) {
            this.selectedItems.set([selectedItem]);
        } else {
            this.selectedItems.set([]);
        }
    }

    protected override async onEntityTextChange(): Promise<void> {
        return;
    }

    protected override mapSelectedItemsToValue(): MarketView[] {
        return this.selectedItems() || [];
    }

    protected override mapValueToSelectedItems(value: MarketView[]): any[] {
        return value || [];
    }

    private async loadMarkets(): Promise<void> {
        const items = await this.marketService.getAll();
        this.items.set(items);
    }
}
